import dayjs from "dayjs"
import { CleaningStatus, CleaningType } from "./cleaningInfo"

export interface Operation {
    id: string
    companyId: string
    companyName: string
    cleaningCompanyId?: string | null
    cleaningCompanyName?: string | null
    placementId?: string
    listingId?: string
    listingName?: string
    commonAreaId?: string
    commonAreaName?: string
    cleanerId: string[] // cleanerId"s"かもしれない
    cleaningDate: string
    startedAt?: number
    finishedAt?: number
    reportedAt?: number
    note: string
    cleaningCompanyMemo: string
    keyboxRotationId?: string
    placement?: "listing" | "commonArea"
    photoTourId?: string
    status: CleaningStatus
    listingManagerMemo: string
    cleaningType: CleaningType
    isDisabled: boolean
    address?: string
    scheduleStart?: number | null
    scheduleEnd?: number | null
    deadlineAt?: number | null
}

export const scheduleTimeTextFromOperation = (operation: Operation) => {
    const start = operation.scheduleStart
    const end = operation.scheduleEnd

    const startDayjs = start ? dayjs.unix(start) : undefined
    const endDayjs = end ? dayjs.unix(end) : undefined

    // 両方ある場合は開始時刻と終了時刻を表示
    if (startDayjs && endDayjs) {
        return `${startDayjs.format("HH:mm")}~${endDayjs.format("HH:mm")}`
    }

    // どちらか片方だけある場合は片方だけ表示
    if (!endDayjs && startDayjs) {
        return `${startDayjs.format("HH:mm")}~終了時刻未定`
    }
    if (!startDayjs && endDayjs) {
        return `開始時刻未定~${endDayjs.format("HH:mm")}`
    }
    return ""
}
